import axios from "..";
import { GET_FINANCIAL_VIEW } from "../../resources/constants";

class financialOverviewService {
  public static async getView(id: string) {
    return {
      data: {
        financialOverview: {
          relocationAmount: 75000,
          lumpSumAmount: 75000,
          graph: {
            categories: [
              {
                type: "Home Finding",
                authorized: 0,
                outofpocket: 0,
                expenses: [
                  {
                    type: "expense",
                    program_payment_detail_uid: 476586,
                    customer_uid: 42745,
                    acct_numb: "720405",
                    acct_desc: "Home Finding- Airfare",
                    acct_uid: 313,
                    acct_parent_uid: 605,
                    status: "AR    ",
                    auth_reference_nbr: "Home Finding",
                    authorized_amount: 750,
                    authorized_date: "2025-04-17T00:00:00.000Z",
                    invoice_amount: 750,
                    paid_amount: 750,
                    paid_financial_date: "2025-05-01T00:00:00.000Z",
                    vendor_name: "Bishop, Elvin",
                    exception: 0,
                  },
                ],
                spentPercent: 40.31,
                unspentPercent: 59.69,
                budget: 1860.66,
                expenseSum: 750,
              },
              {
                type: "Temporary Living",
                authorized: 0,
                outofpocket: 0,
                expenses: [],
                spentPercent: 0,
                unspentPercent: 100,
                budget: 6546.7,
                expenseSum: 0,
              },
              {
                type: "Return Trips Home",
                authorized: 0,
                outofpocket: 0,
                expenses: [],
                spentPercent: 0,
                unspentPercent: 100,
                budget: 1093.4,
                expenseSum: 0,
              },
              {
                type: "Home Sale",
                authorized: 2479,
                outofpocket: 0,
                expenses: [
                  {
                    type: "expense",
                    program_payment_detail_uid: 476587,
                    customer_uid: 42745,
                    acct_numb: "734177",
                    acct_desc: "Home Sale Assistance - Appraisal",
                    acct_uid: 635,
                    acct_parent_uid: 611,
                    status: "AR    ",
                    auth_reference_nbr: "Appraisal",
                    authorized_amount: 500,
                    authorized_date: "2025-05-02T00:00:00.000Z",
                    invoice_amount: 500,
                    paid_amount: 500,
                    paid_financial_date: "2025-05-02T00:00:00.000Z",
                    vendor_name: "Bishop, Elvin",
                    exception: 0,
                  },
                  {
                    type: "authorized",
                    id: "409",
                    version: "0",
                    amount: 750,
                    category: "Home Sale",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Home Sale - Inspection - ddlb_INSTYP_inspection_type",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "6",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "410",
                    version: "0",
                    amount: 850,
                    category: "Home Sale",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Home Sale - Inspection - ddlb_INSTYP_inspection_type",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "6",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "411",
                    version: "0",
                    amount: 879,
                    category: "Home Sale",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Home Sale - Inspection - ddlb_INSTYP_inspection_type",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "6",
                    expenseTypeId: null,
                  },
                ],
                spentPercent: 100,
                unspentPercent: 100,
                budget: 0,
                expenseSum: 500,
              },
              {
                type: "Final Move",
                authorized: 50,
                outofpocket: 0,
                expenses: [
                  {
                    type: "authorized",
                    id: "418",
                    version: "0",
                    amount: 50,
                    category: "Final Move",
                    dateCreated: "2025-05-02T14:17:35.000Z",
                    description: "meals",
                    lastUpdated: "2025-05-02T14:17:35.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "7",
                    expenseTypeId: null,
                  },
                ],
                spentPercent: 4.36,
                unspentPercent: 95.64,
                budget: 1146.6999999999998,
                expenseSum: 0,
              },
              {
                type: "Duplicate Housing",
                authorized: 0,
                outofpocket: 0,
                expenses: [],
                spentPercent: 0,
                unspentPercent: 100,
                budget: 3000,
                expenseSum: 0,
              },
              {
                type: "Household Goods",
                authorized: 20650,
                outofpocket: 0,
                expenses: [
                  {
                    type: "expense",
                    program_payment_detail_uid: 476588,
                    customer_uid: 42745,
                    acct_numb: "738120",
                    acct_desc: "Household Goods - Vehicle Shipment",
                    acct_uid: 407,
                    acct_parent_uid: 612,
                    status: "AR    ",
                    auth_reference_nbr: "Auto Shipment",
                    authorized_amount: 1250,
                    authorized_date: "2025-05-02T00:00:00.000Z",
                    invoice_amount: 1250,
                    paid_amount: 1250,
                    paid_financial_date: "2025-05-02T00:00:00.000Z",
                    vendor_name: "Bishop, Elvin",
                    exception: 0,
                  },
                  {
                    type: "authorized",
                    id: "412",
                    version: "0",
                    amount: 1250,
                    category: "Household Goods",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description: "Household Goods - Vehicle Shipment1",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "9",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "413",
                    version: "0",
                    amount: 1300,
                    category: "Household Goods",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description: "Household Goods - Vehicle Shipment2",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "9",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "414",
                    version: "0",
                    amount: 1900,
                    category: "Household Goods",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Household Goods - International surface shipment estimated total",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "9",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "415",
                    version: "0",
                    amount: 1200,
                    category: "Household Goods",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Household Goods - International air shipment estimated total",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "9",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "416",
                    version: "0",
                    amount: 15000,
                    category: "Household Goods",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description:
                      "Household Goods - Household goods estimated total",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "9",
                    expenseTypeId: null,
                  },
                ],
                spentPercent: 191.34,
                unspentPercent: -91.34,
                budget: 11445.4,
                expenseSum: 1250,
              },
              {
                type: "Other",
                authorized: 0,
                outofpocket: 0,
                expenses: [],
                spentPercent: 0,
                unspentPercent: 100,
                budget: 4000,
                expenseSum: 0,
              },
              {
                type: "International",
                authorized: 4700,
                outofpocket: 0,
                expenses: [
                  {
                    type: "authorized",
                    id: "405",
                    version: "0",
                    amount: 2000,
                    category: "International",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description: "International - Visa and Immigration",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "25",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "406",
                    version: "0",
                    amount: 1500,
                    category: "International",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description: "International - Language Training",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "25",
                    expenseTypeId: null,
                  },
                  {
                    type: "authorized",
                    id: "407",
                    version: "0",
                    amount: 1200,
                    category: "International",
                    dateCreated: "2025-05-01T18:37:46.000Z",
                    description: "International - Cross Cultural Training",
                    lastUpdated: "2025-05-01T18:37:46.000Z",
                    lumpSumId: null,
                    vendorName: null,
                    class: "com.moveplanner.AuthorizedExpense",
                    deleteReason: null,
                    deleted: false,
                    editReason: null,
                    hidden: false,
                    transfereeId: "7041",
                    s3key: null,
                    status: null,
                    accountNumber: null,
                    payee: null,
                    expenseCategoryId: "25",
                    expenseTypeId: null,
                  },
                ],
                spentPercent: 100,
                unspentPercent: 100,
                budget: 0,
                expenseSum: 0,
              },
            ],
            expSum: 2500,
            estSum: 29092.86,
            taxExcludeSum: 0,
            taxSavings: 0,
            taxes: 0,
            totalAuth: 27879,
            remainingLumpSum: 44621,
            grossUpRate: 0.05,
            estExclude: 0,
            projectedTaxSavings: 0,
            lumpSumAfterTaxes: 75000,
            grossUpWorstCase: 75000,
            projectedBurden: 75000,
            actualBurden: 75000,
            withholding: 0,
            opSum: 0,
            mlsIsGrossUp: false,
            taxRate: 0,
            budgetSum: 29092.86,
            remainingBudget: 0,
            benefitRemaining: 44621,
            policyType: "MANAGED_LUMP_SUM",
            taxScenario: "",
          },
        },
      },
    };
    return await axios.get(GET_FINANCIAL_VIEW + "/" + id);
  }
}

export default financialOverviewService;
